import { Card, CardContent, CardHeader, Divider, TextField, Grid, InputAdornment } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { text } from '../../modules/languages/index'
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import { getPlate } from 'src/utils/Common'
const useStyles = makeStyles((theme) => ({
  root: {},
  fieldsYolOdeme: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  contentYolOdeme: {
    minHeight: 430,
  },
}));

function YolOdeme({ className, FisNo, readonly, tasks }) {
  const classes = useStyles();

  const [Tutar, setTutar] = React.useState();
  const [gelinenYer, setGelinenYer] = React.useState('');
  const [gidilenYer, setGidilenYer] = React.useState('');
  const [plaka, setPlaka] = React.useState('');
  const [mesafe, setMesafe] = React.useState();
  const handleSubmit = (event) => {
    event.preventDefault();
  };

  // Güvenli veri erişimi - her zaman array ve en az boş obje
  const getTaskData = () => {
    if (readonly) {
      const filtered = Array.isArray(tasks?.tasks) 
        ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo))
        : [];
      return filtered.length > 0 ? filtered : [{}];
    }
    const loaded = loadBaslandiJob();
    return Array.isArray(loaded) && loaded.length > 0 ? loaded : [{}];
  };
  
  let YolOdemeData = getTaskData();

  if (!readonly && (!YolOdemeData || YolOdemeData.length === 0 || !YolOdemeData[0]?.FisNo)) {
    const current = tasks?.tasks?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
    if (current) {
      saveBaslandiJob(current);
      YolOdemeData = getTaskData();
    }
  }
  
  // Güvenli veri erişimi için yardımcı fonksiyon
  const getSafeData = () => getTaskData()[0] || {};

  useEffect(() => {
    if (!readonly) {
      handleChangePlaka(getPlate());
    }
    const data = getSafeData();
    setTutar(data.YOLODEME_TUTAR);
    setGelinenYer(data.GELINEN_YER || '');
    setGidilenYer(data.GIDILEN_YER || '');
    setPlaka(data.PLAKA || '');
    setMesafe(data.MESAFE);
    // eslint-disable-next-line
  }, []);

  const handleChangeMesafe = (event) => {
    if (readonly) {
      return;
    }
    const jobs = loadBaslandiJob();
    let job = (Array.isArray(jobs) && jobs.length > 0) ? jobs[0] : {};
    setMesafe(event.target.value);
    // tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo))[0]?.MESAFE = event.target.value;
    // let TutarDeger = event.target.value * YolOdemeData[0]?.YOLODEME_BIRIM_FIYAT;
    let TutarDeger = event.target.value * (job.YOLODEME_BIRIM_FIYAT || 0);
    setTutar(TutarDeger);
    job = {
      ...job,
      MESAFE: event.target.value,
      YOLODEME_TUTAR: TutarDeger,
    }
    saveBaslandiJob(job);
    // tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo))[0]?.YOLODEME_TUTAR = TutarDeger;
  };
  const handleChangePlaka = (value) => {
    if (readonly) {
      return;
    }
    const jobs = loadBaslandiJob();
    let job = (Array.isArray(jobs) && jobs.length > 0) ? jobs[0] : {};
    job = { ...job, PLAKA: value };
    saveBaslandiJob(job);
    setPlaka(value);
    // tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo))[0]?.PLAKA = event.target.value;
  };
  const handleChangeGİdilenYer = (event) => {
    if (readonly) {
      return;
    }
    const jobs = loadBaslandiJob();
    let job = (Array.isArray(jobs) && jobs.length > 0) ? jobs[0] : {};
    job = { ...job, GIDILEN_YER: event.target.value };
    saveBaslandiJob(job);
    setGidilenYer(event.target.value);
    // tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo))[0]?.GIDILEN_YER = event.target.value;
  };
  const handleChangeGelinenYer = (event) => {
    if (readonly) {
      return;
    }
    const jobs = loadBaslandiJob();
    let job = (Array.isArray(jobs) && jobs.length > 0) ? jobs[0] : {};
    job = { ...job, GELINEN_YER: event.target.value };
    saveBaslandiJob(job);
    setGelinenYer(event.target.value);
    // tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo))[0]?.GELINEN_YER = event.target.value;
  };


  return (
    <Card className={clsx(classes.root, className)}>
      <CardHeader title={text("YolOdeme")} />
      <Divider />
      <CardContent className={classes.contentYolOdeme}>
        <form className={clsx(classes.root, className)} onSubmit={handleSubmit}>
          <div className={classes.fieldsYolOdeme}>
            <TextField
              label={text("GelinenYer")}
              fullWidth
              name="GelinenYer"
              onChange={handleChangeGelinenYer}
              variant="outlined"
              disabled={readonly}
              value={gelinenYer || ''}

            />
            <TextField
              label={text("GidilenYer")}
              name="GidilenYer"
              fullWidth
              onChange={handleChangeGİdilenYer}
              variant="outlined"
              disabled={readonly}
              value={gidilenYer || ''}
            />
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <TextField
                  label={text("Plaka")}
                  name="Plaka"
                  fullWidth
                  onChange={e => handleChangePlaka(e.target.value)}
                  variant="outlined"
                  disabled={true}
                  value={plaka || ''}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label={text("Mesafe")}
                  name="Mesafe"
                  fullWidth
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={handleChangeMesafe}
                  variant="outlined"
                  disabled={readonly}
                  value={mesafe || 0}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <TextField
                  label={text("BirimFiyat")}
                  name="BirimFiyat"
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        ₺
                      </InputAdornment>
                    ),
                  }}
                  value={YolOdemeData[0]?.YOLODEME_BIRIM_FIYAT || 0}
                  variant="outlined"
                  disabled={readonly}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  name="Tutar"
                  label={text("Tutar")}
                  value={Tutar || 0}
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        ₺
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                  variant="outlined"
                  disabled={readonly}
                />
              </Grid>
            </Grid>
          </div>
        </form>
      </CardContent>
    </Card>
  );
}

YolOdeme.propTypes = {
  className: PropTypes.string,
};


export default connect(
  state => ({ tasks: state.tasks1 })
)(YolOdeme);
